export default "__VITE_ASSET__DuDgfhlL__"